import { Button, Radio } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { InputNumber } from 'antd';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

import React, { useState } from 'react';

import './App.css';
import Equation from './Equation';

const { Title } = Typography;

const educationOptions = [
  'less than high school graduate',
  'high school graduate',
  'post high school training (trade/certification)',
  'some college',
  'college graduate',
  'postgraduate/professional'
]

const ethnicityOptions = [
  'caucasian',
  'black (non-hispanic)',
  'hispanic',
  'asian',
  'native hawaiian/pacific islander',
  'american indian/alaskan native'
]

export function Calculator() {
  const [age, setAge] = useState(50);
  const [smokingHistory, setSmokingHistory] = useState(0);
  const [cigarettes, setCigarettes] = useState(0);
  const [duration, setDuration] = useState(0);
  const [quitTime, setQuitTime] = useState(0);
  const [bronchitisChecked, setBronchitis] = useState(0);
  const [personalHistory, setPersonalHistory] = useState(0);
  const [familyHistory, setFamilyHistory] = useState(0);
  const [education, setEducation] = useState(0);
  const [ethnicity, setEthnicity] = useState(0);
  const [bodyMassIndex, setBodyMassIndex] = useState(0);

  const [calculated, setCalulated] = useState(false);
  const [riskPercent, setRiskPercent] = useState(0);

  const onChange = (e) => {
    setSmokingHistory(e.target.value);
  }
  // education dropdown
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const open = Boolean(anchorEl);

  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // ethnicity dropdown
  const [ethnicAnchorEl, setEthnicAnchorEl] = React.useState(null);
  const [selectedEthnicIndex, setSelectedEthnicIndex] = React.useState(1);
  const ethnicOpen = Boolean(ethnicAnchorEl);

  const handleClickEthnicListItem = (event) => {
    setEthnicAnchorEl(event.currentTarget);
  };

  const handleEthnicMenuItemClick = (event, index) => {
    setSelectedEthnicIndex(index);
    setEthnicAnchorEl(null);
  };

  const handleEthnicClose = () => {
    setEthnicAnchorEl(null);
  };

  const calculateRisk = () => {
    console.log('hitting!')
  }

  return (
    <div className='calculator'>

      {/* age */}
      <div className='section'>
        <Title level={4}>how old are you (in years)?</Title>

        <InputNumber className='number' min={1} max={100} defaultValue={50} size="large" onChange={value => { setAge(value) }} />
      </div>
      {/* are you a... */}
      <div className='section'>
        <Title level={4}>are you a:</Title>
        <div className='checkboxes'>
          <Radio.Group onChange={onChange} value={smokingHistory} style={{ width: '100%' }}>

            <Radio value={0}>person who formerly smoked</Radio>
            <Radio value={1}>person who currently smokes</Radio>
          </Radio.Group>
        </div>
      </div>

      {/* avg # of cigarettes smoked */}
      {(smokingHistory === 1 || smokingHistory === 0) && (
        <>
          <div className='section'>
            <Title level={4} style={{ marginBottom: '0px' }}>average number of cigarettes smoked per day?</Title>
            <span style={{ fontSize: '0.9em' }}>there are about ~25 cigarettes / pack.</span>
            <InputNumber className='number' min={0} max={100} defaultValue={25} size="large" onChange={value => { setCigarettes(value) }} />
          </div>
          {/* how long have you smoked */}
          <div className='section'>
            <Title level={4} style={{ marginBottom: '0px' }}>how long did you / have you been smoking for? (in years)</Title>
            <InputNumber className='number' min={0} max={100} defaultValue={25} size="large" onChange={value => { setDuration(value) }} />
          </div>
          {/* quit-time? */}
          <div className='section'>
            <Title level={4} style={{ marginBottom: '0px' }}>if you have quit smoking, what is your quit-time?</Title>
            <span style={{ fontSize: '0.9em' }}>quit-time = years ago since you quit smoking.</span>
            <InputNumber className='number' min={0} max={100} defaultValue={25} size="large" onChange={value => { setQuitTime(value) }} />
          </div>
        </>
      )}

      {/* COPD, emphysema, bronchitis */}
      <div className='section'>
        <Title level={4}>do you have a diagnosis or past diagnosis of the following: <a href="https://www.lung.org/lung-health-diseases/lung-disease-lookup/copd" target='_blank'>COPD</a>, <a href="https://www.lung.org/lung-health-diseases/lung-disease-lookup/emphysema" target='_blank'>emphysema</a>, or <a href="https://www.lung.org/lung-health-diseases/lung-disease-lookup/chronic-bronchitis" target='_blank'>chronic bronchitis</a>?</Title>
        <div>
          <Radio.Group onChange={value => setBronchitis(value)} style={{ width: '50%' }}>
            <Radio value={1}>yes</Radio>
            <Radio value={0}>no</Radio>
          </Radio.Group>
        </div>
      </div>

      <div className='section'>
        {/* personal history of cancer */}
        <Title level={4}>personal history of cancer</Title>
        <div>
          <Radio.Group onChange={value => setPersonalHistory(value)} style={{ width: '50%' }}>
            <Radio value={1}>yes</Radio>
            <Radio value={0}>no</Radio>
          </Radio.Group>
        </div>
      </div>

      {/* family history of cancer */}
      <div className='section'>
        <Title level={4}>family history of cancer</Title>
        <div>
          <Radio.Group onChange={value => setFamilyHistory(value)} style={{ width: '50%' }}>
            <Radio value={1}>yes</Radio>
            <Radio value={0}>no</Radio>
          </Radio.Group>
        </div>
      </div>

      {/* years of education */}
      <div className='section'>
        <Title level={4}>how many years of education do you have?</Title>

        <List
          component="nav"
          aria-label="years of education"
          sx={{ bgcolor: 'background.paper' }}
          className='education'
        >
          <ListItem
            button
            id="lock-button"
            aria-haspopup="listbox"
            aria-controls="education"
            aria-label="education"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClickListItem}

          >
            <ListItemText
              primary={educationOptions[selectedIndex]}
            />
            {open ? <UpOutlined /> : <DownOutlined />}
          </ListItem>
        </List>

        <Menu
          id="lock-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'lock-button',
            role: 'listbox',
          }}
        >
          {educationOptions.map((option, index) => (
            <MenuItem
              key={option}
              selected={index === selectedIndex}
              onClick={(event) => { handleMenuItemClick(event, index); setEducation(index) }}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </div>

      {/* race/ethnicity */}
      <div className='section'>
        <Title level={4} style={{ marginBottom: '0px' }}>race / ethnicity</Title>
        <span style={{ fontSize: '0.9em' }}>we recognize that these terms are not accepted as the current terminology, and they will be updated. please answer as best you can. the calculations are based on historical terms, and cannot be changed at this time.</span>
        <List
          component="nav"
          aria-label="years of education"
          sx={{ bgcolor: 'background.paper' }}
          className='education'
        >
          <ListItem
            button
            id="lock-button"
            aria-haspopup="listbox"
            aria-controls="education"
            aria-label="education"
            aria-expanded={ethnicOpen ? 'true' : undefined}
            onClick={handleClickEthnicListItem}

          >
            <ListItemText
              primary={ethnicityOptions[selectedEthnicIndex]}
              className='menu'
            />
            {ethnicOpen ? <UpOutlined /> : <DownOutlined />}
          </ListItem>
        </List>

        <Menu
          id="lock-menu"
          anchorEl={ethnicAnchorEl}
          open={ethnicOpen}
          onClose={handleEthnicClose}
          MenuListProps={{
            'aria-labelledby': 'lock-button',
            role: 'listbox',
          }}
        >
          {ethnicityOptions.map((option, index) => (
            <MenuItem
              key={option}
              selected={index === selectedEthnicIndex}
              onClick={(event) => { handleEthnicMenuItemClick(event, index); setEthnicity(index) }}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </div>

      {/* BMI + bmi calculator */}
      <div className='section'>
        <Title level={4} style={{ marginBottom: '0px' }}>body mass index (BMI)</Title>
        <span style={{ fontSize: '0.9em' }}>calculate your bmi <a href="https://bmicalculatorcanada.com/" target='_blank'>here</a>.</span>
        <InputNumber className='number' min={1} max={100} defaultValue={18.7} size="large" onChange={value => { setBodyMassIndex(value) }} />
      </div>

      {/* calculate button */}
      <Button className='calculate' onClick={e => { setRiskPercent(Equation(age, (education + 1), bodyMassIndex, bronchitisChecked.target.value, personalHistory.target.value, familyHistory.target.value, (ethnicity + 1), smokingHistory, cigarettes, duration, quitTime)); setCalulated(true); }}>calculate risk</Button>

      {calculated && (

        <div className='riskResult'>
          your risk of developing lung cancer in the next six years is <span className='percent'>{riskPercent}%.</span> here's what you can do next:
          <ul>
            <li>get in touch with a physician</li>
            <li>contact <a href="http://www.bccancer.bc.ca/screening/lung">bc cancer screening program</a></li>
          </ul>
        </div>

      )}
    </div>
  );
}